"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rules = _interopRequireDefault(require("webmotors-react-pj/webinput/text/validation/rules"));
var _default = _ref => {
  let {
    type = 'default',
    min,
    max,
    required,
    value,
    equal,
    message,
    fnrule
  } = _ref;
  const rulesApply = [];
  const validationByAttributes = {
    required,
    equal,
    min,
    max
  };
  const rulesType = (0, _rules.default)({
    type,
    min,
    max,
    value,
    equal,
    message,
    fnrule
  });
  Object.entries(validationByAttributes).forEach(item => {
    const [key, rule] = item;
    if (rule) {
      rulesApply.push(key);
    }
  });
  if (rulesType[type]) {
    rulesApply.push(type);
  }
  const validationErrors = rulesApply.filter(item => rulesType[item].fn())[0];
  const validationRule = rulesType[validationErrors];
  const validationRequired = validationErrors === 'required';
  const validationShowFn = validationRule && validationRule.fn();
  const validationShow = (!validationRequired && value.length >= 1 || required && validationShowFn) && validationShowFn;
  return Promise.resolve({
    data: validationShow ? validationRule.message : '',
    success: !Boolean(validationShow)
  });
};
exports.default = _default;